import React from "react";

export default function Sidebar({value, setValue}) {
  const arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const arr1 = [
    "000",
    "001",
    "002",
    "003",
    "013",
    "023",
    " 033",
    "133",
    "233",
    "333",
  ];
  const arr2 = ["011", "012", "022", "113", "123", "223"];
  const arr3 = ["111", "112", "122", "222"];

  return (
    <div className="flex justify-center items-center">
      <div className="flex flex-col">
        {arr.map((num) => (
          <button
            className="bg-blue-200 font-semibold w-14 border-2 border-black flex justify-center items-center p-1"
            key={num}
          >
            {num}
          </button>
        ))}
      </div>
      <div className="flex flex-col">
        {arr1.map((num) => (
          <button
            className="bg-blue-200 font-semibold w-14 border-2 border-black flex justify-center items-center p-1"
            key={num}
            onClick={() => {
              setValue({ ...value, [num]: !value[num] });
            }}
            style={{
              textDecorationLine: value[num] ? "line-through" : "none",
              textDecorationStyle: value[num] ? "solid" : "none",
              textDecorationColor: value[num] ? "red" : "black",
              textDecorationThickness: value[num] ? "3px" : "none",
            }}
          >
            {num}
          </button>
        ))}
      </div>
      <div className="flex flex-col">
        {arr2.map((num) => (
          <button
            className="bg-blue-200 font-semibold w-14 border-2 border-black flex justify-center items-center p-1"
            onClick={() => {
              setValue({ ...value, [num]: !value[num] });
            }}
            style={{
              textDecorationLine: value[num] ? "line-through" : "none",
              textDecorationStyle: value[num] ? "solid" : "none",
              textDecorationColor: value[num] ? "red" : "black",
              textDecorationThickness: value[num] ? "3px" : "none",
            }}
            key={num}
          >
            {num}
          </button>
        ))}
      </div>
      <div className="flex flex-col">
        {arr3.map((num) => (
          <button
            className="bg-blue-200 font-semibold w-14 border-2 border-black flex justify-center items-center p-1"
            key={num}
            onClick={() => {
              setValue({ ...value, [num]: !value[num] });
            }}
            style={{
              textDecorationLine: value[num] ? "line-through" : "none",
              textDecorationStyle: value[num] ? "solid" : "none",
              textDecorationColor: value[num] ? "red" : "black",
              textDecorationThickness: value[num] ? "3px" : "none",
            }}
          >
            {num}
          </button>
        ))}
      </div>
    </div>
  );
}
